import {Col, Container, Image, Row} from "react-bootstrap";
import {Setting} from "../../helper/setting";
import axios from "axios";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import EventsCol from "../../component/events/events";
import Loading from "../../component/loading/loading";
import EventHistoryCol from "../../component/events/eventHistory";
import PRow from "../../component/masonry";

function Events(){
    const t = useTranslation()
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const fetchDta = async () => {
        setLoading(true);
        axios.get(Setting.api + 'PublicCmsEvent/GetIncomingEvent?page=1&rows=20',
            {
                method: "get",
                headers: {
                    'Accept-Language': t.i18n.language,
                    'accept': 'text/plain',
                }
            }
        ).then(async function (response) {
            setData(response.data);
            setLoading(false);
        }).catch(function (error) {

        });
    }
    useEffect(() => {
        fetchDta()
    }, [localStorage.getItem("lang") ]);


    return(
        <Container className={"my-3"}>
            {loading ? <Loading /> :

                <PRow key={'x1'}>
                    {
                        data.map((item) => {
                            return (
                                <Col md={3} key={"col"+item['id']} className={"w-100"}>
                                    <EventsCol title={item['name']} id={item['id']} date={item['timing']}
                                                     image={Setting.imagePrefix+item['imageUrl']}/>
                                </Col>
                            )
                        })
                    }
                </PRow>
            }

        </Container>

    )
}
export default Events
